import React from 'react';
import '../styles/MachineKatha.css';

const productSpecs = [
  { label: 'Product Name', value: 'Machine Katha (Machine Catechu)' },
  { label: 'Product Composition', value: 'Natural condensed tannin extract obtained from Acacia Catechu wood (Khair tree)' },
  { label: 'Dangerous Ingredients', value: 'None' },
  { label: 'Available in', value: 'Dark brown square compressed blocks packed in 25 kg bags or customized export packaging' },
];

const industrialUses = [
  'Widely used in vegetable leather tanning industry',
  'Improves leather fullness, softness, and buffability',
  'Used in chrome leather retainage process',
  'Used in shoe leather, saddlery, belts, bags, and upholstery leather',
  'Used as natural tanning and dyeing agent',
  'Used as a natural flavouring and confectionery ingredient in food-grade applications',
  'Preferred ingredient in confectionery and mouth-freshener applications',
];

const medicalUses = [
  'Rich in natural antioxidant compounds',
  'Traditionally used in traditional Indian herbal preparations and natural medicinal formulations',
  'Used in chewable herbal preparations as a natural astringent and wellness ingredient',
  'Used in flavoured mouth fresheners and natural oral care products',
  'Contains polyphenols and natural tannins beneficial in herbal products',
  'Used in traditional remedies for skin-related applications',
  'Natural plant-based extract with therapeutic properties',
];

function MachineKatha() {
  return (
    <div className="mkatha-page">

      {/* Top Banner Image */}
      <div className="mkatha-banner">
        <img
          src="/mll.png"
          alt="Machine Katha Banner"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>

      {/* Main Content */}
      <div className="mkatha-container">
        <div className="mkatha-left">

          <h2 className="mkatha-title">Machine Katha</h2>

          <p className="mkatha-desc">
            <strong>Machine Katha</strong> is a natural condensed tannin extract
            obtained from the heartwood of the <strong>Acacia Catechu tree (Khair)</strong>,
            native to India and South Asia. These dark brown compressed blocks are widely
            known for their high tannin concentration, excellent binding properties, and
            eco-friendly performance. They are extensively used in pan/betel preparations,
            leather tanning, dyeing, traditional Indian herbal preparations, and chemical
            industries.
          </p>

          <p className="mkatha-desc">
            Machine Katha provides firm and consistent quality with improved astringency,
            natural color, and water solubility. Its suitability as a natural flavouring
            and confectionery ingredient makes it equally valued in confectionery and
            mouth-freshener applications. Due to its natural origin and compatibility with
            other vegetable extracts, it is considered an ideal alternative to synthetic
            tanning chemicals.
          </p>

          <p className="mkatha-desc">
            Their excellent antioxidant and natural tanning characteristics also make them
            a preferred base in chewable herbal preparations and flavoured mouth fresheners,
            in addition to their wide use across multiple industrial applications worldwide.
          </p>

          <h3 className="mkatha-subtitle">Product Identification &amp; Specifications:</h3>
          <table className="mkatha-table">
            <tbody>
              {productSpecs.map((s, i) => (
                <tr key={i}>
                  <td className="mkatha-spec-label">{s.label}</td>
                  <td className="mkatha-spec-value">{s.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className="mkatha-subtitle">Industrial Use:</h3>
          <ul className="mkatha-uses">
            {industrialUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

          <h3 className="mkatha-subtitle">Medical Use:</h3>
          <ul className="mkatha-uses">
            {medicalUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}

export default MachineKatha;